import { isValidElement as i } from "react";
import { isEmpty as e } from "../../../helpers/stringHelper.js";
import "clsx";
const s = '[Multiselect - Accessibility Error] O elemento select deve ter um label associado. Informe pelo menos um dos atributos "label" | "aria-label" | "aria-labelledby" com valor v\xE1lido.',
  n = '[Multiselect - Accessibility Error] Quando o state for "loading" \xE9 obrigat\xF3rio informar um "stateMessage" para indicar para os leitores de tela a mensagem de carregamento.',
  d = "[Multiselect - Error] Para utiliza\xE7\xE3o da label no componente \xE9 obrigat\xF3rio a utiliza\xE7\xE3o de um id v\xE1lido.",
  m = _ref => {
    let {
      ariaLabel: r,
      ariaLabelledBy: a,
      label: o,
      state: t,
      stateMessage: l
    } = _ref;
    if (!i(o) && typeof o == "string" && e(o) && e(r) && e(a)) throw new Error(s);
    if (t === "loading" && e(l)) throw new Error(n);
  },
  c = _ref2 => {
    let {
      id: r,
      label: a
    } = _ref2;
    if (!i(a) && typeof a == "string" && e(r)) throw new Error(d);
  };
export { m as validateAccessibilityProps, c as validateLabelAndIdProps };